import React from 'react'

const RowInfo = ({ rowData }) =>{  
        return (
        <div id={"divId"} style={{ display: "flex", alignItems: "center", justifyContent: "center", visibility: "hidden",fontStyle:"normal !important" }}>
                <table>
                <thead style={{ fontStyle: "normal !important" }}>
                    <th style={{ fontStyle: "normal !important" }}>ProjectName</th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <th style={{ fontStyle: "normal !important" }}>ObjectDescription</th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <th style={{ fontStyle: "normal !important" }}>CustomerTag</th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <th style={{ fontStyle: "normal !important" }}>InternalTag</th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </thead>
                <td> <a>{rowData?.specifications?.ProjectName}</a> </td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <td><a>{rowData?.specifications?.ObjectDescription}</a> </td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <td><a>{rowData?.specifications?.CustomerTag}</a> </td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <td><a>{rowData?.specifications?.InternalTag}</a></td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </table>                                                             
       </div>
    );
}
export default RowInfo;
